AccessController = App.loadClass 'admin::Angular/AccessController'
InserterHandler = App.loadClass 'admin::handlers/inserter/InserterHandler'

class exports.InserterController extends AccessController
    constructor: (@scope, @http) ->
        super('inserter', @http)
        App.current_page = new InserterHandler()
        App.sidebar?.open?()
        App.current_page.init()